"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const molecules_1 = require("../../molecules");
const bridge_1 = require("@completeanatomy/bridge");
const device_1 = require("@completeanatomy/device");
const InfoBoxStateProvider_1 = require("../../providers/InfoBoxStateProvider");
const hooks_1 = require("../../hooks");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const preferences_1 = require("@completeanatomy/preferences");
const constants_1 = require("../../constants");
const TabCarouselMobile_1 = require("../TabCarouselMobile");
function InfoBoxTabsCarousel() {
    const { isMobile } = (0, device_1.usePlatform)();
    const availableTabs = (0, hooks_1.useAvailableTabs)(isMobile);
    const defaultTab = (0, hooks_1.useDefaultTab)();
    const bridge = (0, bridge_1.useBridge)();
    const [{ currentTab, previousTab }, dispatchInfoBoxState] = (0, InfoBoxStateProvider_1.useInfoBoxStateContext)();
    const isTabExpanded = !!currentTab;
    const infoBoxTabOrder = (0, preferences_1.useInfoBoxTabsOrder)();
    const availableTabsOrder = infoBoxTabOrder.filter((orderNum) => availableTabs.some(tabNum => tabNum === orderNum));
    (0, react_1.useEffect)(() => {
        if (!isMobile &&
            currentTab === bridge_schema_1.InfoBoxTabType.None &&
            previousTab === bridge_schema_1.InfoBoxTabType.None &&
            !availableTabs.includes(previousTab)) {
            dispatchInfoBoxState((0, hooks_1.selectTab)(bridge_schema_1.InfoBoxTabType.Description));
            bridge === null || bridge === void 0 ? void 0 : bridge.toggleInfoBoxTab(bridge_schema_1.InfoBoxTabType.Description);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentTab]);
    (0, react_1.useEffect)(() => {
        if (defaultTab &&
            availableTabs.includes(defaultTab) &&
            currentTab !== defaultTab) {
            dispatchInfoBoxState((0, hooks_1.selectTab)(defaultTab));
            bridge === null || bridge === void 0 ? void 0 : bridge.toggleInfoBoxTab(defaultTab);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultTab]);
    (0, react_1.useEffect)(() => {
        if (!isMobile &&
            currentTab !== bridge_schema_1.InfoBoxTabType.None &&
            previousTab !== bridge_schema_1.InfoBoxTabType.None &&
            !availableTabs.includes(currentTab)) {
            dispatchInfoBoxState((0, hooks_1.selectTab)(bridge_schema_1.InfoBoxTabType.Description));
            bridge === null || bridge === void 0 ? void 0 : bridge.toggleInfoBoxTab(bridge_schema_1.InfoBoxTabType.Description);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [availableTabs, previousTab, currentTab]);
    if (isMobile) {
        return (0, jsx_runtime_1.jsx)(TabCarouselMobile_1.TabCarouselMobile, { "data-e2e": 'InfoBoxTabsCarousel_TabCarouselMobile' });
    }
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'InfoBoxTabsCarousel_Container', children: [(0, jsx_runtime_1.jsx)(molecules_1.TabButtons, { "data-e2e": 'InfoBoxTabsCarousel_TabButtons' }), (0, jsx_runtime_1.jsx)(TabsContainer, { "data-e2e": 'InfoBoxTabsCarousel_TabsContainer', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isTabExpanded, timeout: 200, mountOnEnter: true, unmountOnExit: true, appear: true, "data-e2e": 'InfoBoxTabsCarousel_CSSTransition', children: (0, jsx_runtime_1.jsx)(TabContainer, { "data-e2e": 'InfoBoxTabsCarousel_TabContainer', children: availableTabsOrder.map((type) => {
                            const direction = Math.sign(availableTabsOrder.indexOf(currentTab) -
                                availableTabsOrder.indexOf(previousTab));
                            const tabShouldBeOpened = isTabExpanded
                                ? currentTab === type
                                : previousTab === type;
                            const TabContent = (0, react_1.lazy)(() => (0, constants_1.getTabComponentByType)(type));
                            return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: tabShouldBeOpened, timeout: 200, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'InfoBoxTabsCarousel_CSSTransition', children: (0, jsx_runtime_1.jsx)(Tab, { direction: direction, "data-e2e": 'InfoBoxTabsCarousel_Tab', children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { "data-e2e": 'InfoBoxTabsCarousel_Suspense', children: (0, jsx_runtime_1.jsx)(TabContent, { "data-e2e": 'InfoBoxTabsCarousel_TabContent' }) }) }) }, type));
                        }) }) }) })] }));
}
exports.default = (0, react_1.memo)(InfoBoxTabsCarousel);
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;

  height: 100%;

  overflow: hidden;
`;
const TabsContainer = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;

  overflow: hidden;
`;
const TabContainer = styled_components_1.default.div `
  display: flex;

  height: auto;
  overflow: hidden;

  &.enter,
  &.appear {
    transform: translateY(-100%);
  }

  &.enter-active,
  &.appear-active {
    transform: translateY(0);
    transition: transform 200ms ease-in-out;
  }

  &.exit {
    transform: translateY(0);
  }

  &.exit-active {
    transform: translateY(-100%);
    transition: transform 200ms ease-in-out;
  }
`;
const Tab = styled_components_1.default.div `
  display: flex;
  flex-flow: column nowrap;
  box-sizing: border-box;
  width: 100%;
  max-height: 100%;

  padding: 0 5px;
  overflow: hidden;

  &.enter {
    position: absolute;
    left: 0;

    transform: translateX(${props => (props.direction > 0 ? 100 : -100)}%);
  }

  &.enter-active {
    position: absolute;
    left: 0;

    transform: translateX(0);

    transition: transform 200ms ease-in-out;
  }

  &.exit {
    transform: translateX(0);

    transition: transform 200ms ease-in-out;
  }

  &.exit-active {
    transform: translateX(${props => (props.direction > 0 ? -100 : 100)}%);

    transition: transform 200ms ease-in-out;
  }
`;
